<template>
  <v-app>
    <AppBar />
    <router-view></router-view>
    <PageFooter />
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar";
import PageFooter from "@/components/PageFooter";
export default {
  name: "App",
  components: { AppBar, PageFooter },
  mounted() {
    // Using the mounted hook to ensure everything is loaded properly
    this.handleResize(); // Initial check
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleResize);
  },

  methods: {
    handleResize() {
      let scrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
      this.$store.dispatch("setWindowDimensions", {
        width: window.innerWidth,
        height: scrollHeight - 50,
      });
    },
  },
};
</script>
